import React, { useState } from "react";
import "index.css";
import { connect } from "react-redux";
import CareTeam from "modules/careTeam/component/careTeam";
import { useQuery } from "@apollo/client";
import { GET_FAMILY_FRIENDS_DATA } from "modules/shareFamilyFriends/actions/familyActions";
import { errorToDisplay } from "shared/actions/helpers";
import { ShowAlert } from "shared/actions/alert";

const CareTeamCont = (props) => {
   const { auth, id = false } = props;
   const patientId = auth?.userCredentials?.user?.id;
   const [careTeam, setCareTeam] = useState([]);
   const isShared = id ? true : false;

   const { loading } = useQuery(GET_FAMILY_FRIENDS_DATA, {
      fetchPolicy: "no-cache",
      variables: {
         user: {
            id: id ? id : patientId,
         },
         type: {
            isActive: true,
            type: "provider",
         },
      },
      onCompleted(result) {
         const data = result?.getCareTeam || [];
         setCareTeam(data);
      },
      onError(err) {
         const errMessage = errorToDisplay(err);
         ShowAlert(errMessage, "error");
      },
   });
   return <CareTeam careTeam={careTeam} loading={loading} {...props} isShared={isShared} />;
};

const mapStateToProps = (state) => {
   return {
      auth: state.auth,
   };
};

export default connect(mapStateToProps, null)(CareTeamCont);
